import {
  FETCH_DSR_LOGS,
  FETCH_DSR_LOGS_SUCCESS,
  FETCH_DSR_LOGS_FAILURE,
  CREATE_DSR_LOG,
  CREATE_DSR_LOG_SUCCESS,
  CREATE_DSR_LOG_FAILURE,
  SUBMIT_DSR_LOG,
  SUBMIT_DSR_LOG_SUCCESS,
  SUBMIT_DSR_LOG_FAILURE,
  UPDATE_DSR_LOG_SECTIONS,
  UPDATE_DSR_LOG_SECTIONS_SUCCESS,
  UPDATE_DSR_LOG_SECTIONS_FAILURE,
  TOGGLE_DSR_SHIFT_SKIPPED,
  TOGGLE_DSR_SHIFT_SKIPPED_SUCCESS,
  TOGGLE_DSR_SHIFT_SKIPPED_FAILURE,
  FETCH_TECHNICIAN_LOG,
  FETCH_TECHNICIAN_LOG_SUCCESS,
  FETCH_TECHNICIAN_LOG_FAILURE,
  UPDATE_TECHNICIAN_LOG,
  UPDATE_TECHNICIAN_LOG_SUCCESS,
  UPDATE_TECHNICIAN_LOG_FAILURE,
  FETCH_MATERIAL_LOG,
  FETCH_MATERIAL_LOG_SUCCESS,
  FETCH_MATERIAL_LOG_FAILURE,
  UPDATE_MATERIAL_LOG,
  UPDATE_MATERIAL_LOG_SUCCESS,
  UPDATE_MATERIAL_LOG_FAILURE,
  FETCH_CONSUMABLES_LOG,
  FETCH_CONSUMABLES_LOG_SUCCESS,
  FETCH_CONSUMABLES_LOG_FAILURE,
  UPDATE_CONSUMABLES_LOG,
  UPDATE_CONSUMABLES_LOG_SUCCESS,
  UPDATE_CONSUMABLES_LOG_FAILURE,
  FETCH_EQUIPMENT_USAGE_LOG,
  FETCH_EQUIPMENT_USAGE_LOG_SUCCESS,
  FETCH_EQUIPMENT_USAGE_LOG_FAILURE,
  UPDATE_EQUIPMENT_USAGE_LOG,
  UPDATE_EQUIPMENT_USAGE_LOG_SUCCESS,
  UPDATE_EQUIPMENT_USAGE_LOG_FAILURE,
  FETCH_EHS_LOG,
  FETCH_EHS_LOG_SUCCESS,
  FETCH_EHS_LOG_FAILURE,
  UPDATE_EHS_LOG,
  UPDATE_EHS_LOG_SUCCESS,
  UPDATE_EHS_LOG_FAILURE,
  ADD_EHS_LOG_ITEM,
  ADD_EHS_LOG_ITEM_SUCCESS,
  ADD_EHS_LOG_ITEM_FAILURE,
  DELETE_EHS_LOG_ITEM,
  DELETE_EHS_LOG_ITEM_SUCCESS,
  DELETE_EHS_LOG_ITEM_FAILURE,
  FETCH_ALL_EHS_ISSUES,
  FETCH_ALL_EHS_ISSUES_SUCCESS,
  FETCH_ALL_EHS_ISSUES_FAILURE,
  FETCH_DOWNTIME_LOG,
  FETCH_DOWNTIME_LOG_SUCCESS,
  FETCH_DOWNTIME_LOG_FAILURE,
  UPDATE_DOWNTIME_LOG,
  UPDATE_DOWNTIME_LOG_SUCCESS,
  UPDATE_DOWNTIME_LOG_FAILURE,
  ADD_DOWNTIME_LOG_ITEM,
  ADD_DOWNTIME_LOG_ITEM_SUCCESS,
  ADD_DOWNTIME_LOG_ITEM_FAILURE,
  DELETE_DOWNTIME_LOG_ITEM,
  DELETE_DOWNTIME_LOG_ITEM_SUCCESS,
  DELETE_DOWNTIME_LOG_ITEM_FAILURE,
  FETCH_DOWNTIME_EQUIPMENTS,
  FETCH_DOWNTIME_EQUIPMENTS_SUCCESS,
  FETCH_DOWNTIME_EQUIPMENTS_FAILURE,
  FETCH_PRODUCTION_LOG,
  FETCH_PRODUCTION_LOG_SUCCESS,
  FETCH_PRODUCTION_LOG_FAILURE,
  UPDATE_PRODUCTION_LOG,
  UPDATE_PRODUCTION_LOG_SUCCESS,
  UPDATE_PRODUCTION_LOG_FAILURE,
  UPSERT_PRODUCTION_ITEM,
  UPSERT_PRODUCTION_ITEM_SUCCESS,
  UPSERT_PRODUCTION_ITEM_FAILURE,
  DELETE_PIPE_GROUP,
  DELETE_PIPE_GROUP_SUCCESS,
  DELETE_PIPE_GROUP_FAILURE,
  DELETE_PRODUCTION_JOINT,
  DELETE_PRODUCTION_JOINT_SUCCESS,
  DELETE_PRODUCTION_JOINT_FAILURE,
  UPDATE_PIPE_GROUP,
  UPDATE_PIPE_GROUP_SUCCESS,
  UPDATE_PIPE_GROUP_FAILURE,
  UPDATE_GROUP_ITEM,
  UPDATE_GROUP_ITEM_SUCCESS,
  UPDATE_GROUP_ITEM_FAILURE,
  UPDATE_PIPE_DATA,
  UPDATE_PIPE_DATA_SUCCESS,
  UPDATE_PIPE_DATA_FAILURE,
  CLEAR_TECHNICIAN_LOG,
  CLEAR_MATERIAL_LOG,
  CLEAR_CONSUMABLES_LOG,
  CLEAR_EQUIPMENT_USAGE_LOG,
  CLEAR_EHS_LOG,
  CLEAR_DOWNTIME_LOG,
  CLEAR_PRODUCTION_LOG,
} from './types';

const fetchDsrLogs = (payload) => ({
  type: FETCH_DSR_LOGS,
  ...payload,
});
const fetchDsrLogsSuccess = (payload) => ({
  type: FETCH_DSR_LOGS_SUCCESS,
  ...payload,
});
const fetchDsrLogsFailure = () => ({
  type: FETCH_DSR_LOGS_FAILURE,
});

// New action creators for DSR log creation and submission
const createDsrLog = (payload) => ({
  type: CREATE_DSR_LOG,
  ...payload,
});
const createDsrLogSuccess = (payload) => ({
  type: CREATE_DSR_LOG_SUCCESS,
  ...payload,
});
const createDsrLogFailure = () => ({
  type: CREATE_DSR_LOG_FAILURE,
});

const submitDsrLog = (payload) => ({
  type: SUBMIT_DSR_LOG,
  ...payload,
});
const submitDsrLogSuccess = (payload) => ({
  type: SUBMIT_DSR_LOG_SUCCESS,
  ...payload,
});
const submitDsrLogFailure = () => ({
  type: SUBMIT_DSR_LOG_FAILURE,
});

// New action creators for updating DSR log sections
const updateDsrLogSections = (payload) => ({
  type: UPDATE_DSR_LOG_SECTIONS,
  ...payload,
});
const updateDsrLogSectionsSuccess = (payload) => ({
  type: UPDATE_DSR_LOG_SECTIONS_SUCCESS,
  ...payload,
});
const updateDsrLogSectionsFailure = () => ({
  type: UPDATE_DSR_LOG_SECTIONS_FAILURE,
});

const toggleDsrShiftSkipped = (payload) => ({
  type: TOGGLE_DSR_SHIFT_SKIPPED,
  ...payload,
});
const toggleDsrShiftSkippedSuccess = (payload) => ({
  type: TOGGLE_DSR_SHIFT_SKIPPED_SUCCESS,
  ...payload,
});
const toggleDsrShiftSkippedFailure = () => ({
  type: TOGGLE_DSR_SHIFT_SKIPPED_FAILURE,
});

// Technician log action creators
const fetchTechnicianLog = (payload) => ({
  type: FETCH_TECHNICIAN_LOG,
  ...payload,
});
const fetchTechnicianLogSuccess = (payload) => ({
  type: FETCH_TECHNICIAN_LOG_SUCCESS,
  ...payload,
});
const fetchTechnicianLogFailure = () => ({
  type: FETCH_TECHNICIAN_LOG_FAILURE,
});

const updateTechnicianLog = (payload) => ({
  type: UPDATE_TECHNICIAN_LOG,
  ...payload,
});
const updateTechnicianLogSuccess = (payload) => ({
  type: UPDATE_TECHNICIAN_LOG_SUCCESS,
  ...payload,
});
const updateTechnicianLogFailure = () => ({
  type: UPDATE_TECHNICIAN_LOG_FAILURE,
});

// New action creators for material log operations
const fetchMaterialLog = (payload) => ({
  type: FETCH_MATERIAL_LOG,
  ...payload,
});

const fetchMaterialLogSuccess = (payload) => ({
  type: FETCH_MATERIAL_LOG_SUCCESS,
  ...payload,
});

const fetchMaterialLogFailure = (payload) => ({
  type: FETCH_MATERIAL_LOG_FAILURE,
  ...payload,
});

const updateMaterialLog = (payload) => ({
  type: UPDATE_MATERIAL_LOG,
  ...payload,
});

const updateMaterialLogSuccess = (payload) => ({
  type: UPDATE_MATERIAL_LOG_SUCCESS,
  ...payload,
});

const updateMaterialLogFailure = (payload) => ({
  type: UPDATE_MATERIAL_LOG_FAILURE,
  ...payload,
});

// New action creators for consumables log operations
const fetchConsumablesLog = (payload) => ({
  type: FETCH_CONSUMABLES_LOG,
  ...payload,
});

const fetchConsumablesLogSuccess = (payload) => ({
  type: FETCH_CONSUMABLES_LOG_SUCCESS,
  ...payload,
});

const fetchConsumablesLogFailure = () => ({
  type: FETCH_CONSUMABLES_LOG_FAILURE,
});

const updateConsumablesLog = (payload) => ({
  type: UPDATE_CONSUMABLES_LOG,
  ...payload,
});

const updateConsumablesLogSuccess = (payload) => ({
  type: UPDATE_CONSUMABLES_LOG_SUCCESS,
  ...payload,
});

const updateConsumablesLogFailure = () => ({
  type: UPDATE_CONSUMABLES_LOG_FAILURE,
});

// New action creators for equipment usage log operations
const fetchEquipmentUsageLog = (payload) => ({
  type: FETCH_EQUIPMENT_USAGE_LOG,
  ...payload,
});

const fetchEquipmentUsageLogSuccess = (payload) => ({
  type: FETCH_EQUIPMENT_USAGE_LOG_SUCCESS,
  ...payload,
});

const fetchEquipmentUsageLogFailure = () => ({
  type: FETCH_EQUIPMENT_USAGE_LOG_FAILURE,
});

const updateEquipmentUsageLog = (payload) => ({
  type: UPDATE_EQUIPMENT_USAGE_LOG,
  ...payload,
});

const updateEquipmentUsageLogSuccess = (payload) => ({
  type: UPDATE_EQUIPMENT_USAGE_LOG_SUCCESS,
  ...payload,
});

const updateEquipmentUsageLogFailure = () => ({
  type: UPDATE_EQUIPMENT_USAGE_LOG_FAILURE,
});

// New action creators for EHS log operations
const fetchEhsLog = (payload) => ({ type: FETCH_EHS_LOG, ...payload });
const fetchEhsLogSuccess = (payload) => ({ type: FETCH_EHS_LOG_SUCCESS, ...payload });
const fetchEhsLogFailure = () => ({ type: FETCH_EHS_LOG_FAILURE });

const updateEhsLog = (payload) => ({ type: UPDATE_EHS_LOG, ...payload });
const updateEhsLogSuccess = (payload) => ({ type: UPDATE_EHS_LOG_SUCCESS, ...payload });
const updateEhsLogFailure = () => ({ type: UPDATE_EHS_LOG_FAILURE });

const addEhsLogItem = (payload) => ({ type: ADD_EHS_LOG_ITEM, ...payload });
const addEhsLogItemSuccess = (payload) => ({ type: ADD_EHS_LOG_ITEM_SUCCESS, ...payload });
const addEhsLogItemFailure = () => ({ type: ADD_EHS_LOG_ITEM_FAILURE });

const deleteEhsLogItem = (payload) => ({ type: DELETE_EHS_LOG_ITEM, ...payload });
const deleteEhsLogItemSuccess = (payload) => ({ type: DELETE_EHS_LOG_ITEM_SUCCESS, ...payload });
const deleteEhsLogItemFailure = () => ({ type: DELETE_EHS_LOG_ITEM_FAILURE });

const fetchAllEhsIssues = (payload) => ({ type: FETCH_ALL_EHS_ISSUES, ...payload });
const fetchAllEhsIssuesSuccess = (payload) => ({ type: FETCH_ALL_EHS_ISSUES_SUCCESS, ...payload });
const fetchAllEhsIssuesFailure = () => ({ type: FETCH_ALL_EHS_ISSUES_FAILURE });

// New action creators for Downtime log operations
const fetchDowntimeLog = (payload) => ({ type: FETCH_DOWNTIME_LOG, ...payload });
const fetchDowntimeLogSuccess = (payload) => ({ type: FETCH_DOWNTIME_LOG_SUCCESS, ...payload });
const fetchDowntimeLogFailure = () => ({ type: FETCH_DOWNTIME_LOG_FAILURE });

const updateDowntimeLog = (payload) => ({ type: UPDATE_DOWNTIME_LOG, ...payload });
const updateDowntimeLogSuccess = (payload) => ({ type: UPDATE_DOWNTIME_LOG_SUCCESS, ...payload });
const updateDowntimeLogFailure = () => ({ type: UPDATE_DOWNTIME_LOG_FAILURE });

const addDowntimeLogItem = (payload) => ({ type: ADD_DOWNTIME_LOG_ITEM, ...payload });
const addDowntimeLogItemSuccess = (payload) => ({
  type: ADD_DOWNTIME_LOG_ITEM_SUCCESS,
  ...payload,
});
const addDowntimeLogItemFailure = () => ({ type: ADD_DOWNTIME_LOG_ITEM_FAILURE });

const deleteDowntimeLogItem = (payload) => ({ type: DELETE_DOWNTIME_LOG_ITEM, ...payload });
const deleteDowntimeLogItemSuccess = (payload) => ({
  type: DELETE_DOWNTIME_LOG_ITEM_SUCCESS,
  ...payload,
});
const deleteDowntimeLogItemFailure = () => ({ type: DELETE_DOWNTIME_LOG_ITEM_FAILURE });

const fetchDowntimeEquipments = (payload) => ({ type: FETCH_DOWNTIME_EQUIPMENTS, ...payload });
const fetchDowntimeEquipmentsSuccess = (payload) => ({
  type: FETCH_DOWNTIME_EQUIPMENTS_SUCCESS,
  ...payload,
});
const fetchDowntimeEquipmentsFailure = () => ({ type: FETCH_DOWNTIME_EQUIPMENTS_FAILURE });

// New action creators for Production log operations
const fetchProductionLog = (payload) => ({ type: FETCH_PRODUCTION_LOG, ...payload });
const fetchProductionLogSuccess = (payload) => ({ type: FETCH_PRODUCTION_LOG_SUCCESS, ...payload });
const fetchProductionLogFailure = () => ({ type: FETCH_PRODUCTION_LOG_FAILURE });

const updateProductionLog = (payload) => ({ type: UPDATE_PRODUCTION_LOG, ...payload });
const updateProductionLogSuccess = (payload) => ({
  type: UPDATE_PRODUCTION_LOG_SUCCESS,
  ...payload,
});
const updateProductionLogFailure = () => ({ type: UPDATE_PRODUCTION_LOG_FAILURE });

const upsertProductionItem = (payload) => ({ type: UPSERT_PRODUCTION_ITEM, ...payload });
const upsertProductionItemSuccess = (payload) => ({
  type: UPSERT_PRODUCTION_ITEM_SUCCESS,
  ...payload,
});
const upsertProductionItemFailure = () => ({ type: UPSERT_PRODUCTION_ITEM_FAILURE });

const deletePipeGroup = (payload) => ({ type: DELETE_PIPE_GROUP, ...payload });
const deletePipeGroupSuccess = (payload) => ({ type: DELETE_PIPE_GROUP_SUCCESS, ...payload });
const deletePipeGroupFailure = () => ({ type: DELETE_PIPE_GROUP_FAILURE });

const deleteProductionJoint = (payload) => ({ type: DELETE_PRODUCTION_JOINT, ...payload });
const deleteProductionJointSuccess = (payload) => ({
  type: DELETE_PRODUCTION_JOINT_SUCCESS,
  ...payload,
});
const deleteProductionJointFailure = () => ({ type: DELETE_PRODUCTION_JOINT_FAILURE });

const updatePipeGroup = (payload) => ({ type: UPDATE_PIPE_GROUP, ...payload });
const updatePipeGroupSuccess = (payload) => ({ type: UPDATE_PIPE_GROUP_SUCCESS, ...payload });
const updatePipeGroupFailure = () => ({ type: UPDATE_PIPE_GROUP_FAILURE });

const updateGroupItem = (payload) => ({ type: UPDATE_GROUP_ITEM, ...payload });
const updateGroupItemSuccess = (payload) => ({ type: UPDATE_GROUP_ITEM_SUCCESS, ...payload });
const updateGroupItemFailure = () => ({ type: UPDATE_GROUP_ITEM_FAILURE });

const updatePipeData = (payload) => ({ type: UPDATE_PIPE_DATA, ...payload });
const updatePipeDataSuccess = (payload) => ({ type: UPDATE_PIPE_DATA_SUCCESS, ...payload });
const updatePipeDataFailure = () => ({ type: UPDATE_PIPE_DATA_FAILURE });

// Clear section data actions
const clearTechnicianLog = () => ({ type: CLEAR_TECHNICIAN_LOG });
const clearMaterialLog = () => ({ type: CLEAR_MATERIAL_LOG });
const clearConsumablesLog = () => ({ type: CLEAR_CONSUMABLES_LOG });
const clearEquipmentUsageLog = () => ({ type: CLEAR_EQUIPMENT_USAGE_LOG });
const clearEhsLog = () => ({ type: CLEAR_EHS_LOG });
const clearDowntimeLog = () => ({ type: CLEAR_DOWNTIME_LOG });
const clearProductionLog = () => ({ type: CLEAR_PRODUCTION_LOG });

export {
  fetchDsrLogs,
  fetchDsrLogsSuccess,
  fetchDsrLogsFailure,
  createDsrLog,
  createDsrLogSuccess,
  createDsrLogFailure,
  submitDsrLog,
  submitDsrLogSuccess,
  submitDsrLogFailure,
  updateDsrLogSections,
  updateDsrLogSectionsSuccess,
  updateDsrLogSectionsFailure,
  toggleDsrShiftSkipped,
  toggleDsrShiftSkippedSuccess,
  toggleDsrShiftSkippedFailure,
  fetchTechnicianLog,
  fetchTechnicianLogSuccess,
  fetchTechnicianLogFailure,
  updateTechnicianLog,
  updateTechnicianLogSuccess,
  updateTechnicianLogFailure,
  fetchMaterialLog,
  fetchMaterialLogSuccess,
  fetchMaterialLogFailure,
  updateMaterialLog,
  updateMaterialLogSuccess,
  updateMaterialLogFailure,
  fetchConsumablesLog,
  fetchConsumablesLogSuccess,
  fetchConsumablesLogFailure,
  updateConsumablesLog,
  updateConsumablesLogSuccess,
  updateConsumablesLogFailure,
  fetchEquipmentUsageLog,
  fetchEquipmentUsageLogSuccess,
  fetchEquipmentUsageLogFailure,
  updateEquipmentUsageLog,
  updateEquipmentUsageLogSuccess,
  updateEquipmentUsageLogFailure,
  fetchEhsLog,
  fetchEhsLogSuccess,
  fetchEhsLogFailure,
  updateEhsLog,
  updateEhsLogSuccess,
  updateEhsLogFailure,
  addEhsLogItem,
  addEhsLogItemSuccess,
  addEhsLogItemFailure,
  deleteEhsLogItem,
  deleteEhsLogItemSuccess,
  deleteEhsLogItemFailure,
  fetchAllEhsIssues,
  fetchAllEhsIssuesSuccess,
  fetchAllEhsIssuesFailure,
  fetchDowntimeLog,
  fetchDowntimeLogSuccess,
  fetchDowntimeLogFailure,
  updateDowntimeLog,
  updateDowntimeLogSuccess,
  updateDowntimeLogFailure,
  addDowntimeLogItem,
  addDowntimeLogItemSuccess,
  addDowntimeLogItemFailure,
  deleteDowntimeLogItem,
  deleteDowntimeLogItemSuccess,
  deleteDowntimeLogItemFailure,
  fetchDowntimeEquipments,
  fetchDowntimeEquipmentsSuccess,
  fetchDowntimeEquipmentsFailure,
  fetchProductionLog,
  fetchProductionLogSuccess,
  fetchProductionLogFailure,
  updateProductionLog,
  updateProductionLogSuccess,
  updateProductionLogFailure,
  upsertProductionItem,
  upsertProductionItemSuccess,
  upsertProductionItemFailure,
  deletePipeGroup,
  deletePipeGroupSuccess,
  deletePipeGroupFailure,
  deleteProductionJoint,
  deleteProductionJointSuccess,
  deleteProductionJointFailure,
  updatePipeGroup,
  updatePipeGroupSuccess,
  updatePipeGroupFailure,
  updateGroupItem,
  updateGroupItemSuccess,
  updateGroupItemFailure,
  updatePipeData,
  updatePipeDataSuccess,
  updatePipeDataFailure,
  clearTechnicianLog,
  clearMaterialLog,
  clearConsumablesLog,
  clearEquipmentUsageLog,
  clearEhsLog,
  clearDowntimeLog,
  clearProductionLog,
};
